export default {
  advertisement: 'Anuncio',
  'advertisement.name-advertisement': 'Nombre de anuncio',
  'advertisement.go-back': 'Volver al listado',
  'advertisement.detail': 'Detalle',
  'advertisement.visualizations': 'Visualizaciones',
  'advertisement.actions': 'Acciones',
  'advertisement.contacts': 'Contactos',
  'advertisement.investment': 'Inversión',
  'advertisement.effectiveness': 'Eficacia',
  'advertisement.cost-action': 'Coste por acción',
};
